async function getAntiForgeryToken() {
    const response = await fetch('api/AntiForgery/GetAntiForgeryToken'.toLocaleLowerCase(), {
        method: 'GET',
        credentials: 'include'
    });
    const data = await response.json();
    return data.token;
}

export { getAntiForgeryToken }